 
import type { FC } from 'react';
import { PapiDaSharedAboutStaff } from '@wix/da-papi-types';
import { Url, URLS } from '@wix/da-url';
import UserSymbol from '@wix/da-shared-react/pkg/User/_partials/UserSymbol';
import UserAvatar from '@wix/da-shared-react/pkg/User/Avatar';
import { Trans, useTranslation } from 'react-i18next';
import PolicyPage from '../Policy';
import s from './About.scss';

export interface Props {
  staffMembers?: PapiDaSharedAboutStaff['positions'];
}

const AboutPage: FC<Props> = ({ staffMembers }) => {
  const { t } = useTranslation('aboutstaff');
  return (
    <PolicyPage>
      <div className={s['about-page']}>
        <div className={s['links']}>
          <ul>
            <li>
              <a href={Url.deviationLink(498282387, 'spyed')}>
                {t('about.ourStory')}
              </a>
            </li>
            <li>
              <a href={URLS.CAREERS}>{t('about.working')}</a>
            </li>
            <li>
              <a href={URLS.ADVERTISE}>{t('about.ads')}</a>
            </li>
            <li>
              <a href={URLS.CONTACT}>{t('about.contact')}</a>
            </li>
            <li>
              <a href={URLS.HELP}>{t('about.faq')}</a>
            </li>
            <li>
              <a href={URLS.ETIQUETTE}>{t('about.etiquette')}</a>
            </li>
            <li>
              <a href={URLS.ACCESSIBILITY_POLICY}>{t('about.accessibility')}</a>
            </li>
          </ul>
        </div>
        <section className={s['column-container']}>
          <Trans
            t={t}
            i18nKey={'about.text'}
            components={{
              h1: <h1 />,
              h2: <h2 />,
              h3: <h3 />,
              h4: <h4 />,
              h5: <h5 />,
              p: <p />,
              b: <b />,
              i: <i />,
              u: <u />,
              em: <em />,
              ol: <ol />,
              ul: <ul />,
              li: <li />,
              table: <table />,
              thead: <thead />,
              tbody: <tbody />,
              tr: <tr />,
              th: <th />,
              td: <td />,
              aboutImg: (
                <img
                  src={`${URLS.CDN}/minish/about/about_deviantart_title.png`}
                  alt="About DeviantArt"
                  className={s['about-img']}
                />
              ),
              trademark: <span className={s['about-trademark']}>™</span>,
              fellaImg: (
                <img
                  src={`${URLS.CDN}/minish/tour/fella_community_about.png?1`}
                  alt="Fella"
                  style={{ float: 'right' }}
                />
              ),
              staffSymbol: <UserSymbol userSymbol="admin" />,
            }}
          />
          <section>
            <div className={s['staffs']}>
              {staffMembers?.map(position => (
                <div key={position.name} className={s['staff']}>
                  <h2>{position.name}</h2>
                  <div className={s['staff-members']}>
                    <div className={s['spacer']}>
                      {position.users?.map(staffer => (
                        <span
                          key={staffer.userId}
                          className={s['staff-member']}
                        >
                          <UserAvatar
                            key={staffer.userId}
                            user={staffer}
                            size={50}
                            withTooltip
                          />
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </section>
      </div>
    </PolicyPage>
  );
};
AboutPage.displayName = 'AboutPage';
export default AboutPage;
